import { Component, OnInit } from "@angular/core";
import { Select } from "@ngxs/store";
import { Observable } from "rxjs";
import { AppState } from "src/store/app/app.state";
import { CompanySettings } from "src/app/services/response-models/companies.response.model";
import { Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { FeaturesState } from "src/store/features/features.state";
import { Feature } from "src/app/services/response-models/features.response.model";
import { User } from "src/app/services/response-models/user.response.model";
import { UsersState } from "src/store/users/users.state";

@Component({
    selector: "app-navigation",
    templateUrl: "./navigation.component.html",
    styleUrls: ["./navigation.component.scss"],
    standalone: false,
})
export class NavigationComponent implements OnInit {
    @Select(AppState.getUser) user$: Observable<User>;
    @Select(AppState.getUserName) userName$: Observable<string>;
    @Select(AppState.getCompanySettings) companySettings$: Observable<CompanySettings>;
    @Select(AppState.getUserHours) userHours$: Observable<string>;
    @Select(AppState.getLang) lang$: Observable<string>;
    @Select(AppState.getMenuStatus) hasMenu$: Observable<string>;
    @Select(FeaturesState.getFeatures) features$: Observable<Feature[]>;
    @Select(UsersState.getNotificationsCount) notifications$: Observable<number>;

    public pagesToShowTheTabs = [
        "/employee/calendar",
        "/employee/users/profile",
        "/employee/projects",
        "/employee/users/notifications",
    ];

    public showTabs = true;

    constructor(private route: Router) {}

    ngOnInit() {
        this.route.events.pipe(filter((x) => (x as any).url)).subscribe((data: any) => {
            this.showTabs = this.pagesToShowTheTabs.includes(data.url);
        });
    }

    public navigateToProjects = (ev: Event) => {
        ev.stopImmediatePropagation();
        this.route.navigate(["employee", "projects"]);
    };
}
